module.exports = __webpack_public_path__ + "static/img/3.6c038ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/3.jpg
// module id = 5Ogl
// module chunks = 0